import {
    Box,
    Stack,
    TextField,
    FormControl,
    FormLabel,
    FormControlLabel,
    Typography,
    Button,
    RadioGroup,
    Radio,
    Divider
} from "@mui/material";

export default function ArrimaPrincipalForm({
    principalForm,
    setPrincipalForm,
}) {
    // ---------------- Generic Handlers ----------------
    const handleChange = (key) => (e) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setPrincipalForm((prev) => ({ ...prev, [key]: value }));
    };

    const handleArrayChange = (arrayName, idx, key) => (e) => {
        const value =
            e.target.type === "checkbox"
                ? e.target.checked ? "Oui" : "Non"
                : e.target.value;
        const updatedArray = [...principalForm[arrayName]];
        updatedArray[idx] = { ...updatedArray[idx], [key]: value };
        setPrincipalForm((prev) => ({ ...prev, [arrayName]: updatedArray }));
    };

    const addArrayItem = (arrayName, template) => {
        setPrincipalForm((prev) => ({
            ...prev,
            [arrayName]: [...prev[arrayName], { ...template }],
        }));
    };

    const removeArrayItem = (arrayName, idx) => {
        const updatedArray = [...principalForm[arrayName]];
        updatedArray.splice(idx, 1);
        setPrincipalForm((prev) => ({ ...prev, [arrayName]: updatedArray }));
    };

    return (
        <Stack spacing={2}>

            {/* ================= Personal Information ================= */}
            <Typography variant="h4" gutterBottom align="center">Declaration d'interet arrima - Principal</Typography>
            <Typography variant="h6">Informations personnelles</Typography>
            <Stack spacing={2}>
                <TextField required label="Nom de famille tel qu’indiqué sur le passeport :" value={principalForm.lastNamePassport} onChange={handleChange("lastNamePassport")} />
                <TextField required label="Prénom tel qu’indiqué sur le passeport :" value={principalForm.firstNamePassport} onChange={handleChange("firstNamePassport")} />
                <TextField label="Autres noms utilisés :" value={principalForm.otherNamesUsed} onChange={handleChange("otherNamesUsed")} />
                <FormControl>
                    <FormLabel>Sexe :</FormLabel>
                    <RadioGroup row value={principalForm.sex} onChange={handleChange("sex")}>
                        <FormControlLabel value="Homme" control={<Radio required />} label="Homme" />
                        <FormControlLabel value="Femme" control={<Radio required />} label="Femme" />
                        <FormControlLabel value="Autre" control={<Radio required />} label="Autre" />
                    </RadioGroup>
                </FormControl>
                <TextField required type="date" label="Date de naissance :" InputLabelProps={{ shrink: true }} value={principalForm.birthDate} onChange={handleChange("birthDate")} />
                <TextField required label="Ville de naissance :" value={principalForm.birthCity} onChange={handleChange("birthCity")} />
                <TextField required label="Pays ou territoire de naissance :" value={principalForm.birthCountry} onChange={handleChange("birthCountry")} />
                <TextField required label="Première citoyenneté :" value={principalForm.firstCitizenship} onChange={handleChange("firstCitizenship")} />
                <TextField label="Deuxième citoyenneté :" value={principalForm.secondCitizenship} onChange={handleChange("secondCitizenship")} />
                <TextField required label="Numéro de passeport :" value={principalForm.passportNumber} onChange={handleChange("passportNumber")} />
                <TextField required label="Pays émetteur du passeport :" value={principalForm.passportIssuingCountry} onChange={handleChange("passportIssuingCountry")} />

                <FormControl>
                    <FormLabel>Avez-vous déjà obtenu un numéro de dossier individuel du Ministère de l’Immigration, de la Francisation et de l’Intégration ?</FormLabel>
                    <RadioGroup row value={principalForm.hasMIFIReferenceNumber}
                        onChange={(e) => {
                            setPrincipalForm((prev) => ({
                                ...prev,
                                hasMIFIReferenceNumber: e.target.value,
                                mifiReferenceNumber: e.target.value === "Non" ? "" : prev.mifiReferenceNumber
                            }))
                        }}>
                        <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                        <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                    </RadioGroup>
                </FormControl>
                {principalForm.hasMIFIReferenceNumber === "Oui" && (
                    <TextField required label="Si oui, indiquez-le:" 
                        slotProps={{
                            inputLabel: { shrink: true }
                        }}
                        value={principalForm.mifiReferenceNumber} onChange={handleChange("mifiReferenceNumber")} />
                )}

                <FormControl>
                    <FormLabel>Avez-vous déjà un numéro de dossier d’Immigration, Réfugiés et Citoyenneté Canada (IRCC) ?</FormLabel>
                    <RadioGroup row value={principalForm.hasIRCCNumber}
                        onChange={(e) => {
                            setPrincipalForm((prev) => ({
                                ...prev,
                                hasIRCCNumber: e.target.value,
                                irccNumber: e.target.value === "Non" ? "" : prev.irccNumber,
                                irccIdentificationNumber: e.target.value === "Non" ? "" : prev.irccIdentificationNumber
                            }))
                        }}>
                        <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                        <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                    </RadioGroup>
                </FormControl>
                {principalForm.hasIRCCNumber === "Oui" && (
                    <>
                        <TextField required label="Si oui, indiquez-le :" 
                            slotProps={{
                                inputLabel: { shrink: true }
                            }}
                            value={principalForm.irccNumber} onChange={handleChange("irccNumber")} />
                        <TextField required label="Numéro d’identification auprès d’IRCC:" value={principalForm.irccIdentificationNumber} onChange={handleChange("irccIdentificationNumber")} />
                    </>
                )}
            </Stack>

            {/* ================= Coordonnées ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Coordonnées</Typography>
            <Stack spacing={2}>
                <TextField required label="Courriel :" type="email" value={principalForm.email} onChange={handleChange("email")} />
                <TextField required label="Adresse de résidence :" value={principalForm.residenceAddress} onChange={handleChange("residenceAddress")} />
                <TextField required label="Pays：" value={principalForm.residenceCountry} onChange={handleChange("residenceCountry")} />
                <TextField required label="Province / État：" value={principalForm.residenceProvince} onChange={handleChange("residenceProvince")} />
                <TextField required label="Ville：" value={principalForm.residenceCity} onChange={handleChange("residenceCity")} />
                <TextField required label="Code postal：" value={principalForm.residencePostalCode} onChange={handleChange("residencePostalCode")} />
                <TextField required label="Téléphone :" value={principalForm.phoneNumber} onChange={handleChange("phoneNumber")} />
            </Stack>

            {/* ================= Situation familiale ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Situation familiale</Typography>
            <Stack spacing={2}>
                <FormControl>
                    <FormLabel>État civil actuel :</FormLabel>
                    <RadioGroup row value={principalForm.maritalStatus} onChange={(e) => {
                        const value = e.target.value;
                        setPrincipalForm(prev => ({
                            ...prev,
                            maritalStatus: value,
                            // Reset spouse-related fields if not married or common-law
                            willAccompanySpouse: (value === "Marie" || value === "Conjoint") ? prev.willAccompanySpouse : "",
                            spouseLastName: (value === "Marie" || value === "Conjoint") ? prev.spouseLastName : "",
                            spouseFirstName: (value === "Marie" || value === "Conjoint") ? prev.spouseFirstName : "",
                            spouseBirthDate: (value === "Marie" || value === "Conjoint") ? prev.spouseBirthDate : "",
                        }));
                    }}>
                        <FormControlLabel value="Celibataire" control={<Radio required />} label="Célibataire" />
                        <FormControlLabel value="Marie" control={<Radio required />} label="Marié(e)" />
                        <FormControlLabel value="Conjoint" control={<Radio required />} label="Conjoint(e) de fait" />
                        <FormControlLabel value="Divorce" control={<Radio required />} label="Divorcé(e)" />
                        <FormControlLabel value="Separe" control={<Radio required />} label="Séparé(e)" />
                        <FormControlLabel value="Veuf" control={<Radio required />} label="Veuf / veuve" />
                    </RadioGroup>
                </FormControl>

                {(principalForm.maritalStatus === "Marie" || principalForm.maritalStatus === "Conjoint") && (
                    <FormControl>
                        <FormLabel>Serez-vous accompagné(e) de votre conjoint(e) dans votre projet d’immigration ?</FormLabel>
                        <RadioGroup
                            row
                            value={principalForm.willAccompanySpouse}
                            onChange={(e) => {
                                const value = e.target.value;
                                setPrincipalForm(prev => ({
                                    ...prev,
                                    willAccompanySpouse: value,
                                    // reset spouse fields if "Oui" or "Non" depending on your requirement
                                    spouseLastName: value === "Oui" ? "" : prev.spouseLastName,
                                    spouseFirstName: value === "Oui" ? "" : prev.spouseFirstName,
                                    spouseBirthDate: value === "Oui" ? "" : prev.spouseBirthDate,
                                }));
                            }}
                        >
                            <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                            <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                        </RadioGroup>
                    </FormControl>
                )}

                {(principalForm.maritalStatus === "Marie" || principalForm.maritalStatus === "Conjoint") && principalForm.willAccompanySpouse === "Non" && (
                    <Stack spacing={2} sx={{ pl: 3 }}>
                        <FormLabel>Si non,  Inscrivez le nom et la date de naissance du/de la conjoint(e)</FormLabel>
                        <TextField required label="Nom(s) de famille :" value={principalForm.spouseLastName} onChange={handleChange("spouseLastName")} />
                        <TextField required label="Prénom(s):" value={principalForm.spouseFirstName} onChange={handleChange("spouseFirstName")} />
                        <TextField required type="date" label="Date de naissance :" InputLabelProps={{ shrink: true }} value={principalForm.spouseBirthDate} onChange={handleChange("spouseBirthDate")} />
                    </Stack>
                )}

                <Typography>
                    Avez-vous des enfants qui vous accompagnent dans votre projet d’immigration ?<br />
                    Si oui, répondez aux questions suivantes :
                </Typography>

                {principalForm.children.map((child, idx) => (
                    <Stack spacing={2} key={idx} sx={{ pl: 3, border: "1px solid #ddd", p: 2, my: 2 }}>
                        <Typography>Enfant-{idx + 1}</Typography>
                        <TextField required fullWidth label="Nom de famille (passeport)" value={child.lastName} onChange={handleArrayChange("children", idx, "lastName")} />
                        <TextField required fullWidth label="Prénom (passeport)" value={child.firstName} onChange={handleArrayChange("children", idx, "firstName")} />
                        <FormControl>
                            <FormLabel>Sexe</FormLabel>
                            <RadioGroup row value={child.sex} onChange={handleArrayChange("children", idx, "sex")}>
                                <FormControlLabel value="Homme" control={<Radio required />} label="Homme" />
                                <FormControlLabel value="Femme" control={<Radio required />} label="Femme" />
                                <FormControlLabel value="Autre" control={<Radio required />} label="Autre" />
                            </RadioGroup>
                        </FormControl>
                        <TextField required fullWidth type="date" label="Date de naissance" InputLabelProps={{ shrink: true }} value={child.birthDate} onChange={handleArrayChange("children", idx, "birthDate")} />
                        <Box>
                            <Button variant="outlined" color="error" onClick={() => removeArrayItem("children", idx)}>Supprimer cet enfant</Button>
                        </Box>
                    </Stack>
                ))}
                <Box>
                    <Button variant="outlined" onClick={() => addArrayItem("children", { lastName: "", firstName: "", sex: "", birthDate: "" })}>Ajouter un enfant</Button>
                </Box>
            </Stack>

            {/* ================= Current Quebec Status ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Situation actuelle au Québec</Typography>
            <Stack spacing={2}>
                <FormControl fullWidth>
                    <FormLabel>
                        Quelle est votre situation actuelle au Québec ? <br />
                        (Cochez ce qui s’applique parmi les permis de travail, d'études ou statuts de visiteur, etc.)*
                    </FormLabel>
                    <TextField required
                        value={principalForm.currentQuebecStatus} onChange={handleChange("currentQuebecStatus")} />
                </FormControl>

                <TextField required label="Numéro de référence :" value={principalForm.currentPermitReferenceNumber} onChange={handleChange("currentPermitReferenceNumber")} />
                <TextField required type="date" label="Date de début :" InputLabelProps={{ shrink: true }} value={principalForm.currentPermitStartDate} onChange={handleChange("currentPermitStartDate")} />
                <TextField required type="date" label="Date de fin :" InputLabelProps={{ shrink: true }} value={principalForm.currentPermitEndDate} onChange={handleChange("currentPermitEndDate")} />
            </Stack>

            {/* ================= Intentions au Québec ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Intentions au Québec</Typography>
            <Stack spacing={2}>
                <FormControl>
                    <FormLabel>Souhaitez-vous vous établir de façon permanente au Québec comme travailleur qualifié ?</FormLabel>
                    <RadioGroup row value={principalForm.intentPermanentWorker} onChange={(e) => setPrincipalForm(prev => ({ ...prev, intentPermanentWorker: e.target.value }))}>
                        <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                        <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                    </RadioGroup>
                </FormControl>

                <FormControl>
                    <FormLabel>Souhaitez-vous occuper un emploi dans une entreprise que vous contrôlez ?</FormLabel>
                    <RadioGroup row value={principalForm.intendOperateControlledBusiness} onChange={(e) => setPrincipalForm(prev => ({ ...prev, intendOperateControlledBusiness: e.target.value }))}>
                        <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                        <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                    </RadioGroup>
                </FormControl>

                <FormControl>
                    <FormLabel>L’emploi que vous envisagez d’occuper se situe-t-il dans un secteur inacceptable ?</FormLabel>
                    <RadioGroup row value={principalForm.employmentSectorUnacceptable} onChange={(e) => setPrincipalForm(prev => ({ ...prev, employmentSectorUnacceptable: e.target.value }))}>
                        <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                        <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                    </RadioGroup>
                </FormControl>
            </Stack>

            {/* ================= Profession principale ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Profession principale</Typography>
            <Stack spacing={2}>
                <TextField required label="Code CNP (Classification nationale des professions) :" value={principalForm.cnpCode} onChange={handleChange("cnpCode")} />
                <TextField required label="Titre de la profession de la CNP:" value={principalForm.cnpTitle} onChange={handleChange("cnpTitle")} />
                <TextField required label="Catégorie Formation, études, expérience et responsabilités (FÉER):" value={principalForm.feerCategory} onChange={handleChange("feerCategory")} />
            </Stack>

            {/* ================= Talent exceptionnel ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Talent exceptionnel</Typography>
            <FormControl>
                <FormLabel>Vous distinguez-vous clairement dans votre profession par une expertise exceptionnelle susceptible de contribuer à la prospérité du Québec ?</FormLabel>
                <RadioGroup row value={principalForm.exceptionalTalent} onChange={(e) => setPrincipalForm(prev => ({ ...prev, exceptionalTalent: e.target.value }))}>
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>

            {/* ================= Offre d’emploi validée ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Offre d’emploi validée</Typography>
            <FormControl>
                <FormLabel>Avez-vous une offre d’emploi validée dans la profession principale visée ?</FormLabel>
                <RadioGroup row value={principalForm.hasValidatedJobOffer} onChange={(e) => setPrincipalForm(prev => ({ ...prev, hasValidatedJobOffer: e.target.value }))}>
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>

            {/* ================= Lieu d’établissement ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Lieu d’établissement</Typography>
            <Stack spacing={2}>
                <TextField required label="Dans quelle ville ou municipalité avez-vous l'intention de vous établir ?" value={principalForm.intendedCity} onChange={handleChange("intendedCity")} />
                <TextField required label="Région du Québec" value={principalForm.intendedRegion} onChange={handleChange("intendedRegion")} />
            </Stack>

            {/* ================= Scolarité / Education array ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Scolarité</Typography>
            <FormControl component="fieldset">
                <FormLabel component="legend">
                    Avez-vous un diplôme supérieur à l’école primaire ?
                </FormLabel>

                <RadioGroup
                    row
                    value={principalForm.hasEducationAbovePrimary}
                    onChange={(e) => {
                        const value = e.target.value;
                        setPrincipalForm(prev => ({
                            ...prev,
                            hasEducationAbovePrimary: value,
                            hasComparativeEvaluation: value === "Non" ? "" : prev.hasComparativeEvaluation,
                            integrateComparativeEvaluation: value === "Non" ? "" : prev.integrateComparativeEvaluation,
                            education: value === "Non" ? [{
                                diploma: "",
                                diplomaIssuingCountry: "",
                                studiesStartDate: "",
                                studiesEndDate: "",
                                diplomaTitle: "",
                                diplomaAuthority: "",
                                educationDomain: "",
                                educationField: "",
                                educationSpeciality: ""
                            }] : prev.education
                        }));
                    }}
                >
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>

            {principalForm.hasEducationAbovePrimary === "Oui" && (
                <Stack spacing={2}>
                    <FormControl component="fieldset" sx={{ mb: 2 }}>
                        <FormLabel>
                            Avez-vous une Évaluation comparative des études effectuées hors du Québec après le 31 janvier 2013 ?
                        </FormLabel>

                        <RadioGroup
                            row
                            value={principalForm.hasComparativeEvaluation}
                            onChange={(e) => setPrincipalForm(prev => ({ ...prev, hasComparativeEvaluation: e.target.value }))}
                        >
                            <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                            <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                        </RadioGroup>
                    </FormControl>

                    <FormControl component="fieldset">
                        <FormLabel>
                            Souhaitez-vous que les résultats soient intégrés à votre Déclaration d’intérêt ?
                        </FormLabel>

                        <RadioGroup
                            row
                            value={principalForm.integrateComparativeEvaluation}
                            onChange={handleChange("integrateComparativeEvaluation")}
                        >
                            <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                            <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                        </RadioGroup>
                    </FormControl>

                    <Typography sx={{ color: "red", fontWeight: 500 }}>
                        S'il vous plaît, commencez à écrire votre éducation dès le lycée :
                    </Typography>
                    {principalForm.education.map((edu, idx) => (
                        <Stack spacing={2} key={idx} sx={{ pl: 3, border: "1px solid #ddd", p: 2, my: 2 }}>
                            <Typography> {`Éducation ${idx + 1}`} </Typography>
                            <TextField required fullWidth label="Diplôme :" value={edu.diploma} onChange={handleArrayChange("education", idx, "diploma")} />
                            <TextField required fullWidth label="Pays émetteur :" value={edu.diplomaIssuingCountry} onChange={handleArrayChange("education", idx, "diplomaIssuingCountry")} />
                            <TextField required fullWidth type="date" label="Début des études :" InputLabelProps={{ shrink: true }} value={edu.studiesStartDate} onChange={handleArrayChange("education", idx, "studiesStartDate")} />
                            <TextField required fullWidth type="date" label="Fin des études :" InputLabelProps={{ shrink: true }} value={edu.studiesEndDate} onChange={handleArrayChange("education", idx, "studiesEndDate")} />
                            <TextField required fullWidth label="Intitulé du diplôme :" value={edu.diplomaTitle} onChange={handleArrayChange("education", idx, "diplomaTitle")} />
                            <TextField required fullWidth label="Autorité émettrice:" value={edu.diplomaAuthority} onChange={handleArrayChange("education", idx, "diplomaAuthority")} />
                            <Typography>Domaine de formation:</Typography>
                            <TextField required fullWidth label="Domaine:" value={edu.educationDomain} onChange={handleArrayChange("education", idx, "educationDomain")} />
                            <TextField required fullWidth label="Filiere:" value={edu.educationField} onChange={handleArrayChange("education", idx, "educationField")} />
                            <TextField required fullWidth label="Specialite:" value={edu.educationSpeciality} onChange={handleArrayChange("education", idx, "educationSpeciality")} />
                            <Box>
                                <Button variant="outlined" color="error" onClick={() => removeArrayItem("education", idx)}>Supprimer</Button>
                            </Box>
                        </Stack>
                    ))}
                    <Box>
                        <Button variant="outlined" onClick={() => addArrayItem("education", { diploma: "", diplomaIssuingCountry: "", studiesStartDate: "", studiesEndDate: "", diplomaTitle: "", diplomaAuthority: "", educationDomain: "", educationField: "", educationSpeciality: "" })}>Ajouter un diplôme</Button>
                    </Box>
                </Stack>
            )}

            {/* ================= Carrière 5 dernières années array ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Carrière (5 dernières années)</Typography>
            {principalForm.career.map((job, idx) => (
                <Stack spacing={2} key={idx} sx={{ pl: 3, border: "1px solid #ddd", p: 2, my: 2 }}>
                    <Typography>{`Travail ${idx + 1}`}</Typography>
                    <TextField required type="date" label="Date de début :" InputLabelProps={{ shrink: true }} value={job.startDate} onChange={handleArrayChange("career", idx, "startDate")} />
                    <FormControl>
                        <FormLabel>Occupez-vous toujours ce poste ?</FormLabel>
                        <RadioGroup row value={job.stillWorking} onChange={(e) => {
                            const updatedArray = [...principalForm.career];
                            updatedArray[idx] = {
                                ...updatedArray[idx],
                                stillWorking: e.target.value,
                                endDate: ""
                            };
                            setPrincipalForm((prev) => ({ ...prev, career: updatedArray }));
                        }}>
                            <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                            <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                        </RadioGroup>
                    </FormControl>
                    {job.stillWorking === "Non" && (
                        <TextField required type="date" label="Si non, date de fin :" InputLabelProps={{ shrink: true }} value={job.endDate} onChange={handleArrayChange("career", idx, "endDate")} />
                    )}

                    <TextField required label="Type d’occupation:" value={job.jobType} onChange={handleArrayChange("career", idx, "jobType")} />
                    <FormControl>
                        <FormLabel>Type d’emploi</FormLabel>
                        <RadioGroup
                            value={job.employmentType}
                            onChange={handleArrayChange("career", idx, "employmentType")}
                        >
                            <FormControlLabel value="Temps plein" control={<Radio required />} label="Temps plein" />
                            <FormControlLabel value="Temps partiel" control={<Radio required />} label="Temps partiel" />
                            <FormControlLabel value="Stage" control={<Radio required />} label="Stage" />
                            <FormControlLabel value="Congé parental" control={<Radio required />} label="Congé parental" />
                            <FormControlLabel value="Arrêt de travail" control={<Radio required />} label="Arrêt de travail" />
                            <FormControlLabel value="Chômage" control={<Radio required />} label="Chômage" />
                            <FormControlLabel value="Bénévolat" control={<Radio required />} label="Bénévolat" />
                        </RadioGroup>
                    </FormControl>
                    <TextField required label="Titre:" value={job.title} onChange={handleArrayChange("career", idx, "title")} />
                    <TextField required label="Nom de l'entreprise ou de l'organisme :" value={job.companyName} onChange={handleArrayChange("career", idx, "companyName")} />
                    <FormControl>
                        <FormLabel>Êtes-vous propriétaire de l'entreprise?</FormLabel>
                        <RadioGroup row value={job.isOwner} onChange={handleArrayChange("career", idx, "isOwner")}>
                            <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                            <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                        </RadioGroup>
                    </FormControl>
                    <TextField required label="Pays ou territoire:" value={job.country} onChange={handleArrayChange("career", idx, "country")} />
                    <TextField required label="Province ou État:" value={job.province} onChange={handleArrayChange("career", idx, "province")} />
                    <TextField required label="Nombre moyen d'heures travaillées par semaine :" value={job.weeklyHours} onChange={handleArrayChange("career", idx, "weeklyHours")} />
                    <TextField required label="Titre de l'emploi:" value={job.jobTitle} onChange={handleArrayChange("career", idx, "jobTitle")} />
                    <Box>
                        <Button variant="outlined" color="error" onClick={() => removeArrayItem("career", idx)}>Supprimer</Button>
                    </Box>
                </Stack>
            ))}
            <Box>
                <Button variant="outlined" onClick={() => addArrayItem("career", { startDate: "", stillWorking: "", endDate: "", employmentType: "", jobType: "", title: "", companyName: "", isOwner: "", country: "", province: "", weeklyHours: "", jobTitle: "" })}>Ajouter un emploi</Button>
            </Box>

            {/* ================= Compétences en français ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Compétences en français</Typography>
            <FormControl>
                <FormLabel>Pouvez-vous démontrer vos compétences linguistiques en français par un diplôme ou un certificat de test reconnu par le Ministère obtenu dans les 2 dernières années ?</FormLabel>
                <RadioGroup
                    row
                    value={principalForm.hasFrenchTest}
                    onChange={(e) => {
                        const value = e.target.value;
                        setPrincipalForm(prev => ({
                            ...prev,
                            hasFrenchTest: value,
                            frenchTestType: value === "Non" ? "" : prev.frenchTestType,
                            frenchCandidateNumber: value === "Non" ? "" : prev.frenchCandidateNumber,
                            frenchTestDate: value === "Non" ? "" : prev.frenchTestDate,
                            frenchTestCenterName: value === "Non" ? "" : prev.frenchTestCenterName,
                            frenchTestCenterCity: value === "Non" ? "" : prev.frenchTestCenterCity,
                            frenchTestCenterCountry: value === "Non" ? "" : prev.frenchTestCenterCountry,
                            frenchSpeaking: value === "Non" ? "" : prev.frenchSpeaking,
                            frenchListening: value === "Non" ? "" : prev.frenchListening,
                            frenchWriting: value === "Non" ? "" : prev.frenchWriting,
                            frenchReading: value === "Non" ? "" : prev.frenchReading,
                        }));
                    }}
                >
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>
            {principalForm.hasFrenchTest === "Oui" && (
                <Stack spacing={2}>
                    <TextField required label="Titre du diplôme ou test : (TCF, TEF, DELF...)" value={principalForm.frenchTestType} onChange={handleChange("frenchTestType")} />
                    <TextField required label="Numéro du candidat ou de l’attestation :" value={principalForm.frenchCandidateNumber} onChange={handleChange("frenchCandidateNumber")} />
                    <TextField required type="date" label="Date du test :" InputLabelProps={{ shrink: true }} value={principalForm.frenchTestDate} onChange={handleChange("frenchTestDate")} />
                    <TextField required label="Nom du centre agréé :" value={principalForm.frenchTestCenterName} onChange={handleChange("frenchTestCenterName")} />
                    <TextField required label="Ville :" value={principalForm.frenchTestCenterCity} onChange={handleChange("frenchTestCenterCity")} />
                    <TextField required label="Pays ou territoire :" value={principalForm.frenchTestCenterCountry} onChange={handleChange("frenchTestCenterCountry")} />
                    <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
                        Résultats :
                    </Typography>
                    <TextField required label="Expression orale :" value={principalForm.frenchSpeaking} onChange={handleChange("frenchSpeaking")} />
                    <TextField required label="Compréhension orale :" value={principalForm.frenchListening} onChange={handleChange("frenchListening")} />
                    <TextField required label="Expression écrite:" value={principalForm.frenchWriting} onChange={handleChange("frenchWriting")} />
                    <TextField required label="Compréhension écrite：" value={principalForm.frenchReading} onChange={handleChange("frenchReading")} />
                </Stack>
            )}

            {/* ================= Compétences en anglais ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Compétences en anglais</Typography>
            <FormControl>
                <FormLabel>Pouvez-vous démontrer vos compétences en anglais par un test reconnu obtenu dans les 2 dernières années ?</FormLabel>
                <RadioGroup
                    row
                    value={principalForm.hasEnglishTest}
                    onChange={(e) => {
                        const value = e.target.value;
                        setPrincipalForm(prev => ({
                            ...prev,
                            hasEnglishTest: value,
                            englishTestType: value === "Non" ? "" : prev.englishTestType,
                            englishTestDate: value === "Non" ? "" : prev.englishTestDate,
                            englishTestNumber: value === "Non" ? "" : prev.englishTestNumber,
                            englishTestCenterNumber: value === "Non" ? "" : prev.englishTestCenterNumber,
                            englishTestCountry: value === "Non" ? "" : prev.englishTestCountry,
                            englishSpeaking: value === "Non" ? "" : prev.englishSpeaking,
                            englishListening: value === "Non" ? "" : prev.englishListening,
                            englishWriting: value === "Non" ? "" : prev.englishWriting,
                            englishReading: value === "Non" ? "" : prev.englishReading,
                        }));
                    }}
                >
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>
            {principalForm.hasEnglishTest === "Oui" && (
                <Stack spacing={2}>
                    <TextField required label="Titre du test (IELTS)" value={principalForm.englishTestType} onChange={handleChange("englishTestType")} />
                    <TextField required type="date" label="Date du test :" InputLabelProps={{ shrink: true }} value={principalForm.englishTestDate} onChange={handleChange("englishTestDate")} />
                    <TextField required label="Numéro du test :" value={principalForm.englishTestNumber} onChange={handleChange("englishTestNumber")} />
                    <TextField required label="Numéro du centre agréé :" value={principalForm.englishTestCenterNumber} onChange={handleChange("englishTestCenterNumber")} />
                    <TextField required label="Pays ou territoire :" value={principalForm.englishTestCountry} onChange={handleChange("englishTestCountry")} />
                    <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
                        Résultats :
                    </Typography>
                    <TextField required label="Expression orale ：" value={principalForm.englishSpeaking} onChange={handleChange("englishSpeaking")} />
                    <TextField required label="Compréhension orale ：" value={principalForm.englishListening} onChange={handleChange("englishListening")} />
                    <TextField required label="Expression écrite ：" value={principalForm.englishWriting} onChange={handleChange("englishWriting")} />
                    <TextField required label="Compréhension écrite：" value={principalForm.englishReading} onChange={handleChange("englishReading")} />
                </Stack>
            )}

            {/* ================= Informations supplémentaires ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Informations supplémentaires</Typography>
            <Stack spacing={2}>
                <FormControl>
                    <FormLabel>Êtes-vous actuellement employé au Québec par une organisation internationale non gouvernementale (OING) ayant une entente avec le gouvernement du Québec pour faciliter l'établissement permanent de leurs employés ?</FormLabel>
                    <RadioGroup
                        row
                        value={principalForm.worksForINGO}
                        onChange={(e) => {
                            const value = e.target.value;
                            setPrincipalForm(prev => ({
                                ...prev,
                                worksForINGO: value,
                                ingoName: value === "Non" ? "" : prev.ingoName,
                                quebecResidenceCityOutsideCMM: value === "Non" ? "" : prev.quebecResidenceCityOutsideCMM,
                                quebecResidenceStartDate: value === "Non" ? "" : prev.quebecResidenceStartDate,
                            }));
                        }}
                    >
                        <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                        <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                    </RadioGroup>
                </FormControl>
                {principalForm.worksForINGO === "Oui" && (
                    <>
                        <TextField
                            required
                            label="Si oui, nom :"
                            value={principalForm.ingoName}
                            onChange={(e) => setPrincipalForm(prev => ({ ...prev, ingoName: e.target.value }))}
                        />
                        <FormLabel>Dans quelle ville ou municipalité du Québec habitez-vous (hors Communauté métropolitaine de Montréal) ?</FormLabel>
                        <TextField
                            required
                            value={principalForm.quebecResidenceCityOutsideCMM}
                            onChange={(e) => setPrincipalForm(prev => ({ ...prev, quebecResidenceCityOutsideCMM: e.target.value }))}
                        />
                        <TextField
                            required
                            type="date"
                            label="Début Date de résidence :"
                            slotProps={{
                                inputLabel: { shrink: true }
                            }}
                            value={principalForm.quebecResidenceStartDate}
                            onChange={(e) => setPrincipalForm(prev => ({ ...prev, quebecResidenceStartDate: e.target.value }))}
                        />
                    </>
                )}
            </Stack>

            {/* ================= Études au Québec ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Études au Québec</Typography>
            <FormControl>
                <FormLabel>Avez-vous étudié dans un établissement d’enseignement au Québec ?</FormLabel>
                <RadioGroup row value={principalForm.studiedInQuebec} onChange={(e) => setPrincipalForm(prev => ({ ...prev, studiedInQuebec: e.target.value }))}>
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>

            {/* ================= Famille au Québec ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Famille au Québec</Typography>
            <FormControl>
                <FormLabel>Souhaitez-vous vous établir hors de la CMM ?</FormLabel>
                <RadioGroup row value={principalForm.intendSettleOutsideCMM} onChange={(e) => setPrincipalForm(prev => ({ ...prev, intendSettleOutsideCMM: e.target.value }))}>
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>

            {/* ================= Profession principale réglementée ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Profession principale réglementée</Typography>
            <FormControl>
                <FormLabel>Votre profession principale ou celle envisagée est-elle réglementée par une autorité au Québec ?</FormLabel>
                <RadioGroup row value={principalForm.isProfessionRegulated} onChange={(e) => setPrincipalForm(prev => ({ ...prev, isProfessionRegulated: e.target.value }))}>
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>

            {/* ================= Demandes antérieures ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Demandes antérieures</Typography>
            <FormControl>
                <FormLabel>Avez-vous déjà présenté une demande de sélection permanente au Québec pour laquelle une décision finale n’a pas encore été rendue ?</FormLabel>
                <RadioGroup row value={principalForm.hasPendingSelectionApplication} onChange={(e) => setPrincipalForm(prev => ({ ...prev, hasPendingSelectionApplication: e.target.value }))}>
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>

            <FormControl>
                <FormLabel>Avez-vous déjà présenté une demande, ou été inclus dans une demande, ayant été refusée pour renseignements ou documents faux ou trompeurs au cours des 5 dernières années ?</FormLabel>
                <RadioGroup row value={principalForm.hasMisrepresentationRefusalLast5Years} onChange={(e) => setPrincipalForm(prev => ({ ...prev, hasMisrepresentationRefusalLast5Years: e.target.value }))}>
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>
        </Stack>
    );
}
